import React, { useEffect, useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Button } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../Layout/Header/Header";
import ReactLoading from 'react-loading'
import "../../index.css";

function Feriados() {
    let { isAuth, user1 } = useContext(AuthContext);
    let [dias, setDias] = useState([]);
    let [force, setForce] = useState(0)
    let [loading, setLoading] = useState(true)
    let [id, setId] = useState()
    let [limiteCanceladas, setLimiteCanceladas] = useState(0)
    let [mesesBloqueo, setMesesBloqueo] = useState(0)

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API}feriados`, {
            headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
        })
            .then((data) => { setLimiteCanceladas(data.data[0].limiteCanceladas); setMesesBloqueo(data.data[0].mesesBloqueo); setDias(data.data[0].fechas); setId(data.data[0]._id); setLoading(false) })
            .catch((err) => console.log(err));

        // eslint-disable-next-line
    }, []);

    function guardarCambios() {
        setLoading(true)
        axios.patch(`${process.env.REACT_APP_API}feriados/${user1.id}/${id}`,
            {
                fechas: dias,
                limiteCanceladas: limiteCanceladas,
                mesesBloqueo: mesesBloqueo,
            },
            {
                headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}`, },
            }
        )
            .then((data) => {
                Swal.fire({ icon: "success", title: "Guardado", text: "Se guardaron los cambios", });
                setLoading(false)
            })
            .catch((err) => {
                Swal.fire({ icon: "error", title: "Error", text: "No se pudieron guardar los cambios", });
                setLoading(false)
            });
    }

    return (
        <>
            {isAuth ? (
                user1.role === "admin" ? (
                    <>
                        <Header />
                        <br /><br />

                        <center>

                            <h1>Parametros</h1>
                            <br />

                            <div style={{ display: "flex", justifyContent: "center" }}>

                                <div className="col">
                                    <h6>Limite de cancelaciones</h6>
                                    <input label="Limite de cancelaciones" placeholder={limiteCanceladas} type="number" onChange={(e) => { setLimiteCanceladas(e.target.value) }} />
                                    <Button onClick={() => guardarCambios()}>Guardar cambios</Button>
                                </div>

                                <div className="col">
                                    <h6>Meses de bloqueo</h6>
                                    <input label="Meses de bloqueo" placeholder={mesesBloqueo} type="number" onChange={(e) => { setMesesBloqueo(e.target.value) }} />
                                    <Button onClick={() => guardarCambios()}>Guardar cambios</Button>
                                </div>

                            </div>

                            <br />
                            <h6 className="margin">Dias Feriados</h6>

                        </center>

                        <center>


                            <div className="row">

                                <div className="col">
                                    <input type="date" onChange={(e) => { dias.push(e.target.value); setForce(force + 1) }} />
                                    <Button onClick={() => guardarCambios()}>Guardar cambios</Button>
                                    <br /><br />
                                    <div style={{ display: "flex", justifyContent: "flex-start", flexWrap: "wrap", gap: "10px" }}>
                                        {dias.map((dia) => {
                                            return (
                                                <div style={{ minWidth: "150px", padding: "5px", backgroundColor: "cornflowerblue", color: "white", borderRadius: "10px" }}>
                                                    <span key={dia}>{dia} <Button style={{ borderRadius: "10px" }} variant="danger" size="sm" onClick={() => { setDias(dias.filter((e) => e !== dia)) }}>
                                                        {/* icono basura */}
                                                        <i className="far fa-trash-alt"></i>
                                                    </Button></span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        </center>

                        {loading ?
                            <center>
                                <div className='loading'><ReactLoading type={'spin'} color={'cornflowerblue'} height={'5vw'} width={'5vw'} /></div>
                            </center>
                            : null}
                    </>
                ) : undefined
            ) : undefined
            }
        </>
    );
}

export default Feriados;
